import { FilterOption } from "../Filter/Filter";

export const TableSizeOptions: Array<FilterOption & { tableSize: number }> = [
  { id: 1, label: "FR", tableSize: 9 },
  { id: 2, label: "SH", tableSize: 6 },
  { id: 3, label: "HU", tableSize: 2 },
];
